<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/payment'"></fgb-page-header>
<div class="text-center pt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
